module.exports = __webpack_public_path__ + "img/Crescente.bd823589.svg";